import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { photoSrc } from "@/lib/api";

const Row = ({ label, value }) => (
  <div className="flex items-center justify-between border-b border-white/10 py-2.5">
    <span className="text-[10px] font-mono uppercase tracking-[0.22em] text-slate-500">{label}</span>
    <span className="text-xs font-mono uppercase tracking-[0.12em] text-slate-200">{value || "—"}</span>
  </div>
);

export const Lightbox = ({ photo, onClose, onEnquire }) => (
  <AnimatePresence>
    {photo && (
      <motion.div
        data-testid="lightbox-modal"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[70] bg-[var(--ekal-bg)]/92 backdrop-blur-md flex items-center justify-center p-4 sm:p-8"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.96, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.96, y: 20 }}
          transition={{ type: "spring", stiffness: 200, damping: 24 }}
          className="relative max-w-6xl w-full max-h-[88vh] grid grid-cols-1 lg:grid-cols-[1fr_300px] bg-[#12151C] border border-white/15 overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            data-testid="lightbox-close-btn"
            onClick={onClose}
            className="absolute top-3 right-3 z-10 bg-black/60 border border-white/20 p-2 text-slate-200 hover:text-[var(--ekal-accent)] hover:border-[var(--ekal-accent)] transition-colors"
            aria-label="Close"
          >
            <X size={18} />
          </button>
          <div className="bg-black flex items-center justify-center min-h-[40vh] lg:min-h-0">
            <img src={photoSrc(photo)} alt={photo.title} className="max-h-[88vh] w-full object-contain" />
          </div>
          <div className="p-6 flex flex-col">
            <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-amber-400 mb-2">{photo.sport}</p>
            <h3 className="font-heading font-extrabold uppercase tracking-tight text-2xl leading-none mb-5">
              {photo.title}
            </h3>
            <Row label="License" value={photo.license} />
            <div className="mt-auto pt-6">
              <button
                data-testid="lightbox-enquire-btn"
                onClick={() => {
                  onClose();
                  onEnquire(`Photo Licensing — "${photo.title}"`);
                }}
                className="w-full bg-[var(--ekal-accent)] hover:bg-red-600 text-white text-xs font-mono uppercase tracking-[0.2em] px-5 py-3.5 transition-colors"
              >
                Enquire About Licensing
              </button>
            </div>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
